import { defineStore } from "pinia";
import { store } from "../index";

interface ProductState {
  viewData: ProductData;
  editData: ProductData;
  refresh: number;
}

export const useProductStore = defineStore("product", {
  state: (): ProductState => {
    return {
      viewData: {} as ProductData,
      editData: {} as ProductData,
      refresh: 0
    };
  },
  getters: {
    getViewData(): ProductData {
      return this.viewData;
    },
    getEditData(): ProductData {
      return this.editData;
    },
    getRefresh(): number {
      return this.refresh;
    },
  },
  actions: {
    /**@description 更新即将预览的data
     * */
    updateViewData(data: ProductData) {
      this.$patch((state) => {
        state.viewData = data;
      });
    },
    /**@description 更新即将编辑的data
     * */
    updateEditData(data: ProductData) {
      this.$patch((state) => {
        state.editData = data;
      });
    },
    refreshData() {
      this.refresh = this.refresh + 1;
    }
  }
});

export const useProductStoreWithOut = () => {
  return useProductStore(store);
};
